import MovementsByTypeTab from './MovementsByTypeTab'

export default MovementsByTypeTab
